import { reducer } from './newCollection';
import { statusCodes } from 'Helpers/http';

export const TYPE = 'CAMPAIGNS';
export const API_URL = '/api/cpm/v1/campaigns';

export const initialState = {
    elements: {},
    isFetching: {},
    isError: {},
    campaignsNotFound: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case `RECEIVE_ELEMENT_${TYPE}`: {
            const campaign = action.data.data;

            return reducer(state, {
                ...action,
                data: {
                    data: {
                        ...campaign,
                        id: campaign.campaign_url
                    }
                }
            }, TYPE);
        }

        case `ERROR_ELEMENT_${TYPE}`: {
            const { data } = action;
            const newState = reducer(state, action, TYPE);

            if (data && data.statusCode === statusCodes.BAD_REQUEST && data.message === 'CAMPAIGN_NOT_FOUND') {
                return {
                    ...newState,
                    campaignsNotFound: {
                        ...newState.campaignsNotFound,
                        [action.url]: true
                    }
                };
            }

            return newState;
        }

        default:
            return reducer(state, action, TYPE);
    }
};
